class BaseRepository {
    data = [];
}

export default BaseRepository;